import React, { Component } from 'react';

//componentes
import PlanillaM from './planillam'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanillaM />
            </div>
        );
    }

}
export default Index;